import { computed } from 'vue';
import { useStore } from 'vuex';
import { browserStorageSetItem, browserStorageRemoveItem } from '@/utilities/browser-storage.util';
import useIsElectronApp from '@/utilities/composables/useIsElectronApp';
import {
  loginWithAuthProvider,
  electronLoginWithAuthProvider,
} from '@/utilities/loginWithAuthProvider';
import constants from '@/utilities/constants';
import { loggedOutGoogleAccountKey, loggedOutAppleAccountKey } from '@/types/login';

declare global {
  interface Window {
    electron: any;
  }
}

export default function useProviderLogin() {
  const store = useStore();
  const { isElectronApp } = useIsElectronApp();

  const user = computed(() => {
    return store.getters.getUser || {};
  });

  const origin = computed(() => {
    return window.location.origin;
  });

  const redirectRoute = computed(() => {
    return store.getters.getRedirectRouteAfterLogin;
  });

  const redirectPath = computed(() => {
    return Object.keys(redirectRoute.value).length ? redirectRoute.value.fullPath : '';
  });

  const clickHandler = async (providerId: string) => {
    browserStorageRemoveItem('redirectRouteAfterLogin');
    if (user.value.id) {
      logOut(providerId);
      return;
    }

    logIn(providerId);
  };

  const logOut = async (providerId: string) => {
    await store.dispatch('logOut');
    if (providerId === 'google') {
      browserStorageSetItem(loggedOutGoogleAccountKey, true);
    } else if (providerId === 'apple') {
      browserStorageSetItem(loggedOutAppleAccountKey, true);
    }
  };

  const logIn = async (providerId: string) => {
    const { electron } = window;
    if (isElectronApp.value && electron?.send) {
      const vueAppEnv = process.env.VUE_APP_ENV as string;
      if (vueAppEnv in constants.desktopRedirectRoutes) {
        electronLoginWithAuthProvider(
          constants.desktopRedirectRoutes[
            vueAppEnv as keyof typeof constants.desktopRedirectRoutes
          ],
          (url: any) => electron.send('auth-redirect-channel', url)
        );
      }
    } else {
      loginWithAuthProvider(
        store.getters.getRoutes.users,
        `${origin.value}${redirectPath.value}`,
        providerId
      );
    }
  };

  return {
    clickHandler,
    logOut,
    logIn,
  };
}
